import requests from "./httpServices";

const CouponServices = {
  getAllCoupons() {
    return requests.get("/coupon/active");
  },
  updateCouponQuantity(CouponID) {
    return requests.put(`/coupon/${CouponID}/updateQuantity`);
  },
  getShowingCoupons() {
    return requests.get("/coupon/show");
  },
};

export default CouponServices;
